import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ModelTaskTableBodyRow from "./ModelTaskTableBodyRow";
import { ACTION_ROW_HEIGHT } from "./rowConstants";

const previousPageLabel = (previousPage, t) => {
	if (previousPage.isError) return t("action.retryLoadingPreviousTasks");
	if (previousPage.isFetching) return t("message.loading");
	return t("action.loadPreviousTasks");
};

const PreviousPageRow = ({ previousPage, columnCount, classes }) => {
	const { t } = useTranslation();
	if (!previousPage.hasPage) return null;
	return (
		<ModelTaskTableBodyRow
			columnCount={columnCount}
			height={ACTION_ROW_HEIGHT}
			className={previousPage.isFetching ? classes.tableActionBusy : classes.tableAction}
			onClick={previousPage.isFetching ? undefined : previousPage.fetch}
		>
			{previousPageLabel(previousPage, t)}
		</ModelTaskTableBodyRow>
	);
};

PreviousPageRow.propTypes = {
	previousPage: PropTypes.shape({
		hasPage: PropTypes.bool.isRequired,
		isFetching: PropTypes.bool.isRequired,
		isError: PropTypes.bool.isRequired,
		fetch: PropTypes.func.isRequired,
	}).isRequired,
	columnCount: PropTypes.number.isRequired,
	classes: PropTypes.object.isRequired,
};

export default PreviousPageRow;
